import PropTypes from 'prop-types';
import React from 'react';

import TextField from './base/TextField';

import useResetOnDeps from './FilterBar/hooks/useResetOnDeps';

export default function FormTextField({
  input,
  meta,
  disabled,
  errorMessage,
  dependsOn = null,
  defaultValue = null,
  isResetOnDepsEnabled = true,
  labelIcon,
  labelIconPosition,
  dataCy,
  ...rest
}) {
  const { name, value, onChange, onPaste, ...restInput } = input;
  const { submitting, error, touched, submitFailed } = meta;

  useResetOnDeps(dependsOn, onChange, defaultValue, isResetOnDepsEnabled);
  return (
    <TextField
      dataCy={dataCy}
      disabled={disabled || submitting}
      errorMessage={
        errorMessage || ((touched || submitFailed) && error) || null
      }
      inputProps={restInput}
      labelIcon={labelIcon}
      labelIconPosition={labelIconPosition}
      name={name}
      value={value}
      onChange={onChange}
      onPaste={onPaste}
      {...rest}
    />
  );
}

FormTextField.propTypes = {
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
};

FormTextField.defaultProps = {
  disabled: false,
  errorMessage: '',
};
